export const FETCH__ASSET_DETAILS = 'FETCH__ASSET_DETAILS';
export const FETCH__ASSET_DETAILS__SUCCESS = 'FETCH__ASSET_DETAILS__SUCCESS';
export const FETCH__ASSET_DETAILS__FAIL = 'FETCH__ASSET_DETAILS__FAIL';